import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  padding-top: 0.5rem;

  @media (min-width: 1024px) {
    padding-top: 0;
  }
`;

const Categories = styled.div`
  word-break: break-word;
`;

const Category = styled.div`
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

const CategoryTitle = styled.h4`
  font-size: 0.875rem;
  line-height: 1.35;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;

  @media (min-width: 768px) {
    font-size: 1rem;
    line-height: 1.5;
  }
`;

const CategoryContent = styled.p`
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.4;
  color: #374151;

  @media (min-width: 768px) {
    font-size: 0.875rem;
    line-height: 1.5;
  }
`;

export default function SkillCategoriesSection() {
  return (
    <Wrapper>
      <Categories>
        <Category>
          <CategoryTitle>Libraries/APIs</CategoryTitle>
          <CategoryContent>
            React, Node.js, Redux-Saga, Redux form, Stripe, Stripe API, React
            Redux, React Router, REST APIs, Context API, Vue, React hook form,
            MobX, Google Maps, daisyUI, Web3.js, API development, Google Maps
            API, React Query, Web worker, Playwright, Spotify API, GSAP,
            Chart.js
          </CategoryContent>
        </Category>

        <Category>
          <CategoryTitle>Tools</CategoryTitle>
          <CategoryContent>
            Git, Redux Thunk, NPM, Figma, GitHub, JSX, Shadcn, React Apollo,
            Photoshop CC, Postman, Gulp, MongoDB Atlas, Amazon CloudWatch,
            Amazon CloudFront, Firebase authentication, Webpack, Adobe
            Experience design (XD), Canvas, Mailchimp, Pivotal Tracker,
            Stencil.js, FullCalendar, Prisma, Amazon Simple Queue Service (SQS),
            Amazon Simple Notification Service (SNS), Terraform, Cloud
            development kit for Terraform (CDKTF)
          </CategoryContent>
        </Category>

        <Category>
          <CategoryTitle>Languages</CategoryTitle>
          <CategoryContent>
            JavaScript, HTML5, CSS, TypeScript, Sass, HTML, CSS3, ECMAScript
            (ES6), SCSS, GraphQL, TypeScript 3, Ruby
          </CategoryContent>
        </Category>

        <Category>
          <CategoryTitle>Frameworks</CategoryTitle>
          <CategoryContent>
            Next.js, Redux, Bootstrap, Material UI, Tailwind CSS, MUI CSS, JSON
            Web Tokens (JWT), React-Bootstrap, Express.js, RedwoodJS, Swagger,
            Cypress, tRPC, Svelte, Serverless framework, React Native, Ruby on
            Rails 7
          </CategoryContent>
        </Category>

        <Category>
          <CategoryTitle>Paradigms</CategoryTitle>
          <CategoryContent>
            Agile, Responsive layout, Responsive web design (RWD), UI design, UX
            design, E2E testing, REST
          </CategoryContent>
        </Category>

        <Category>
          <CategoryTitle>Platforms</CategoryTitle>
          <CategoryContent>
            MacOS, Contentful, Docker, Netlify, Visual Studio Code (VS Code),
            Firebase, AWS Lambda, Vercel, Amazon Web Services (AWS), Google
            Cloud Platform (GCP), GreenSock animation platform (GSAP)
          </CategoryContent>
        </Category>

        <Category>
          <CategoryTitle>Storage</CategoryTitle>
          <CategoryContent>
            IndexedDB, Database management systems (DBMS), JSON, Amazon S3 (AWS
            S3), Google Cloud, MongoDB
          </CategoryContent>
        </Category>

        <Category>
          <CategoryTitle>Industry expertise</CategoryTitle>
          <CategoryContent>Banking &amp; finance</CategoryContent>
        </Category>

        <Category>
          <CategoryTitle>Other</CategoryTitle>
          <CategoryContent>
            Gatsby, Software development lifecycle (SDLC), Web development,
            English, Operating systems, Zustand, Stripe payments, Front-end,
            Cloudinary, Data visualization, Styled-components, Front-end
            development, Web components, Atomic design, UI components, User
            interface (UI), Responsive UI, UI development, Firebase hosting,
            Content management systems (CMS), Animation, CSS3 animation,
            Front-end architecture, Single-page applications (SPAs), API
            integration, SWR, Component libraries, Design systems, Figma to
            React, UI testing, Analytics, Reusable libraries, Application state
            management, Pixel perfect, Mobile first, Mobile-first design,
            Responsiveness, Dashboards, Accessibility, Monorepos, Open source,
            Data structures, Chakra UI, Full-stack development, Google SEO, SEO
            tools, Apollo, Startups, APIs, Storybook, eCommerce, GoDaddy,
            Deployment, Full-stack, Serverless, User experience (UX), Fintech,
            Strapi, Networking, Web3, i18n, Vite, Data transformation,
            Middleware, RESTFul APIs, Lottie, UX pattern design, Software
            architecture, Back-end development, Turborepo, Headless CMS, Framer,
            SVG, Visualization design, ESLint, PWA, Progressive web applications
            (PWAs), CI/CD pipelines, Gaming, WCAG 2, Web content accessibility
            guidelines (WCAG)
          </CategoryContent>
        </Category>
      </Categories>
    </Wrapper>
  );
}
